import '../../UsersScreen/UserTable.css'
import React, { useEffect, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";

import { fetchEditUserExam, fetchGetFilteredUserExam, fetchUsersExam } from '../ExamApi'
import ConfirmModal from '../../../components/_modals/ConfirmModal';
import { useSelector } from 'react-redux';
import { selectTranslations } from '../../../services/i18n/i18nSlice';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

import plus_img from '../../../assets/images/plus_white.svg'
import { USER_EXAM_STATUS } from '../../../config/constants';

// Funzione per recuperare dati dall'API


const ExamTable = (props) => {

    const t = useSelector(selectTranslations)

    const [data, setData] = useState([]);
    const [nextCursor, setNextCursor] = useState(null);
    const [previousCursor, setPreviousCursor] = useState(null);
    const [pageCount, setPageCount] = useState(1)
    const [loading, setLoading] = useState(false);
    const [currentCursor, setCurrentCursor] = useState(null);

    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "Elimina",
        closeCta: "Annulla"
    })

    const openResetmodal = (user_exam_id) => {
      if(user_exam_id){
        setConfirmModal({
                ...confirmModal,
                show:true,
                title: t.exam.delete_user_exam,
                text: t.exam.delete_user_exam_text,
                onClose: ()=>closeConfirmModal(),
                onConfirm: ()=>handleDeleteUserExam(user_exam_id)
            })
      }
    }

    const closeConfirmModal = () => {
      setConfirmModal({
        ...confirmModal,
        show: false,
        onConfirm: null
      })
    }

    const handleDeleteUserExam = async (user_exam_id) => {
      if(user_exam_id){
        try {
            // Sostituisci con il tuo endpoint API
            const response = await fetchEditUserExam(user_exam_id,{
                deleted: true
            })
            if(response.success){
              closeConfirmModal()
              toast.success("Tentativo eliminato")
              fetchAndSetData(currentCursor);
            }
        } catch (error) {
            toast.error(`Errore durante il recupero dei dati ${error}`)
            return null;
        }
      }
    }

    const fetchDataFromApi = async (cursor) => {
        try {
            // Sostituisci con il tuo endpoint API
            let response = null
            if(props?.isSearch ) 
              response = await fetchGetFilteredUserExam({
                limit: 15,
                start_cursor: cursor,
                ...(props?.examId && {
                  exam_id: props?.examId
                }),
                ...(props?.state && {
                  state: props?.state
                }),
              }) 
            else
              response = await fetchUsersExam(props.examId,{
                  limit: 15,
                  start_cursor: cursor
              })
            return response.data;
        } catch (error) {
            console.error("Errore durante il recupero dei dati", error);
            return null;
        }
    };

    const columns = [
        // Colonna per accedere all'email dall'oggetto annidato "details"
        {
            accessorFn: (row) => row.user_data?.email,
            header: "Email",
        },
        {
            accessorFn: (row) => row.user_data?.firstname,
            header: "Nome",
        },
        {
            accessorFn: (row) => row.user_data?.lastname,
            header: "Cognome",
        },
        {
            accessorFn: (row) => row.state,
            header: "Stato",
            cell: ({row}) => (
              <>
                {!row?.original?.deleted ?
                    <span className='status_label' style={{color:`${USER_EXAM_STATUS[row?.original?.state]?.color}`, background: `${USER_EXAM_STATUS[row?.original?.state]?.background}`}}>{USER_EXAM_STATUS[row?.original?.state]?.text}</span> 
                :
                    <span className='status_label' style={{color:`${USER_EXAM_STATUS['deleted']?.color}`, background: `${USER_EXAM_STATUS['deleted']?.background}`}}>{USER_EXAM_STATUS['deleted']?.text}</span> 
                }
              </>
            )
        },
        {
            accessorFn: (row) => row.total_score,
            header: "Punteggio totale",
        },
        {
            accessorFn: (row) => new Date(row.start_date)?.toLocaleString(),
            header: "Data Ora inizio",
        },
        {
            accessorFn: (row) => new Date(row.end_date)?.toLocaleString(),
            header: "Data Ora fine",
        },
        {
            id: "actions", // ID univoco per la colonna
            header: "Azioni",
            cell: ({ row }) => (
                <div className='d-flex justify-content-between'>
                  <Link target="_blank" to={`/exams/detailed_user_exam/${props.examId}/${row.original.user_exam_id}`}>
                    <button >
                      <img src={plus_img} />
                      Apri dettagli
                    </button>
                  </Link>
                </div>
            ),
        },
    ];

    const getRowStyle = (deleted) => {
        if (deleted) {
            return { backgroundColor: "red", color: "#fff" };
        } 
        return {}; // Default, nessuna colorazione
    };

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    const fetchAndSetData = async (cursor, action) => {
        setLoading(true);
        const response = await fetchDataFromApi(cursor);
        if (response) {
          console.log(response);
          
            setData(response.user_exams);
            setNextCursor(response.next_cursor);
            setPreviousCursor(previousCursor ? cursor : null);
        }
        setLoading(false);
    };

    // Recupera i dati al montaggio del componente e quando cambia il cursore
    useEffect(() => {
        fetchAndSetData(currentCursor);
    }, [currentCursor]);

    const handleNext = () => {
        if (nextCursor) {
            setCurrentCursor(nextCursor);
            setPageCount(pageCount => pageCount + 1 )
        }
    };

    const handlePrevious = () => {
        if (previousCursor) {
            setCurrentCursor(previousCursor);
            setPageCount(pageCount => pageCount - 1 )
        } else {
            setCurrentCursor();
            setPageCount(pageCount => pageCount - 1 )
        }
    };

    useEffect(() => {
        fetchAndSetData();
    }, [props.examId, props.state]);

   return (
    <div className='userTable'> 
      {loading ? (
        <p>Caricamento...</p>
      ) : (
        <table>
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id}>
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id}
                style={getRowStyle(row.original.deleted)}
              >
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div className='d-flex justify-content-between mt-3'>
        <button onClick={handlePrevious} disabled={!previousCursor && pageCount === 1}>
          Precedente
        </button>
        <button onClick={handleNext} disabled={!nextCursor}>
          Successivo
        </button>
      </div>

      <ConfirmModal props={confirmModal} />

    </div>
  );
};

export default ExamTable;
